import React, { useEffect, useState } from 'react';
import { Grid, pn, useElementBreakpoints } from '@compass/core';
import { Select } from 'components';
import {
    StudentFilter as StudentFilterModel,
    StudentFilterResource,
    LkStudentDisplayFilterId,
} from 'generated/openApi';
import { useParticipantsData } from '../contexts/ParticipantsDataContext';
import ApiService from 'services/apiService';

export const ParticipantsFilterControls = () => {
    const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
    const { 
        filter, 
        updateFilter, 
        activeSchoolYear,
        schoolYears,
    } = useParticipantsData();

    // Fetch StudentFilterResource for program filter and properties
    const [resource, setResource] = useState<StudentFilterResource>({} as StudentFilterResource);
    const properties = resource.properties || [];

    useEffect(() => {
        ApiService.students.getFilterResource().then((response) => {
            setResource(response);
        });
    }, []);

    const displayedYear = filter.schoolYear ?? activeSchoolYear ?? null;

    const schoolYearField = () => {
        const propertyName = pn<StudentFilterModel>("schoolYears");
        const property = properties.find((x) => x.propertyName === propertyName);

        // Convert schoolYears array to options format
        const yearOptions = schoolYears.map(year => ({
            id: year,
            name: `${year}-${year + 1}`
        }));

        return (
            <Select
                modelProperty={property}
                value={yearOptions.find((x) => x.id === displayedYear)}
                options={yearOptions}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => updateFilter({ schoolYear: value?.id ?? null })}
            />
        );
    };

    const programField = () => {
        const propertyName = pn<StudentFilterModel>("programIds");
        const property = properties.find((x) => x.propertyName === propertyName);

        return (
            <Select
                modelProperty={property}
                value={resource.programs?.find((x) => x.id === filter.programId)}
                options={resource.programs}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => updateFilter({ programId: value?.id ?? null })}
            />
        );
    };

    // Check if tenant should see the program filter
    const showProgramFilter = resource.displayFilters?.some(
        x => x.id === LkStudentDisplayFilterId.Program
    );

    // Don't render until we have schoolYears from backend
    if (schoolYears.length === 0) {
        return null;
    }

    return (
        <Grid ref={breakpointsRef} container spacing="sm" sx={{ mb: 2 }}>
            <Grid item xs={smallFieldBreakpoints}>
                {schoolYearField()}
            </Grid>

            {showProgramFilter && (
                <Grid item xs={smallFieldBreakpoints}>
                    {programField()}
                </Grid>
            )}
        </Grid>
    );
};